import { readCookieConsent } from "@/lib/cookie-consent";

// C-Tribe Society Google Ad Grants account (293-811-9744).
export const GOOGLE_ADS_ID = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID || "AW-18526499169";
export const GOOGLE_ADS_APPLICATION_LABEL = "IB2CCJzy6qMdEOHij4JF";
export const GOOGLE_ADS_PURCHASE_LABEL = "TDXyCLihy6QdEOHij4JF";
const ENABLED = process.env.NODE_ENV === "production";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export function isGoogleAdsEnabled() {
  return ENABLED;
}

// Defines gtag and queues Consent Mode v2 defaults (everything denied) before
// gtag.js can load. gtag.js replays the queue in order once it arrives.
export function ensureGtagWithDeniedDefaults() {
  if (typeof window.gtag === "function") return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // gtag.js only accepts the Arguments object, not a plain array.
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
  });
  window.gtag("js", new Date());
}

/** Counts a finished CLabs application. Only sent with marketing consent. */
export function trackApplicationConversion(formSlug: string) {
  if (typeof window === "undefined" || !ENABLED || typeof window.gtag !== "function") return;
  if (!readCookieConsent()?.marketing) return;
  window.gtag("event", "conversion", {
    send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_APPLICATION_LABEL}`,
    form_slug: formSlug,
  });
}

/**
 * Counts a paid pass or ticket checkout with its value. Only sent with
 * marketing consent. transaction_id lets Google drop duplicates on reload.
 */
export function trackPurchaseConversion(transactionId: string, value: number, currency: string) {
  if (typeof window === "undefined" || !ENABLED || typeof window.gtag !== "function") return;
  if (!readCookieConsent()?.marketing) return;
  window.gtag("event", "conversion", {
    send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_PURCHASE_LABEL}`,
    value,
    currency: currency.toUpperCase(),
    transaction_id: transactionId,
  });
}
